export function normalizeProfileEmail(email) {
	return typeof email === "string" ? email.trim().toLowerCase() : "";
}

export function isSsoManagedEmailOrganization(organization) {
	if (!organization) {
		return false;
	}

	const enterprise = organization.enterprise === true || organization.enterprise === 1 || organization.enterprise === "1";
	const tokenIssuer = typeof organization.enterprise_tokenIssuer === "string" ? organization.enterprise_tokenIssuer.trim() : "";
	return enterprise && tokenIssuer !== "";
}

export function hasSsoManagedEmailOrganization(organizations) {
	return Array.isArray(organizations) && organizations.some(isSsoManagedEmailOrganization);
}
